import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink,RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-footer',
    imports: [RouterLink, RouterLinkActive],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  constructor(private router: Router) { }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
}
